module.exports = __webpack_public_path__ + "static/media/icon_mobile.9b732353.svg";